import { SEARCH_ENTITY_TYPES, type SearchEntityType } from '@/shared/api/search';

/** `validateSearch` of `/search` (`AM-132 point 10–11`): `q` and the type chip live in the URL. */
export interface SearchResultsSearch {
  q?: string;
  entityType?: SearchEntityType;
}

export function searchResultsSearchSchema(search: Record<string, unknown>): SearchResultsSearch {
  const result: SearchResultsSearch = {};

  const q = search['q'];
  if (typeof q === 'string' && q.trim().length > 0) {
    result.q = q;
  }

  const entityType = search['entityType'];
  if (
    typeof entityType === 'string' &&
    SEARCH_ENTITY_TYPES.includes(entityType as SearchEntityType)
  ) {
    result.entityType = entityType as SearchEntityType;
  }

  return result;
}
